import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';
import { manifestService } from '_services';
import { ViewManifest } from './ViewManifest';
import { toast } from 'react-toastify';
import { dateTimeConstants } from '_constants/datetime.constants';

const DATE_FORMAT = 'MMMM DD, YYYY, h:mm A';

const formatVersionDate = (hist) => {
  if (hist.added_date) {
    // Backend may already return a PST-formatted string
    if (typeof hist.added_date === 'string' && Number.isNaN(Number(hist.added_date))) {
      return hist.added_date;
    }

    const timestamp = Number(hist.added_date);
    if (!Number.isNaN(timestamp) && timestamp > 0) {
      return moment
        .unix(timestamp)
        .tz(dateTimeConstants.PST_TIMEZONE)
        .format(DATE_FORMAT);
    }

    return moment(hist.added_date).format(DATE_FORMAT);
  }

  if (hist.created_at) {
    return moment
      .utc(hist.created_at)
      .tz(dateTimeConstants.PST_TIMEZONE)
      .format(DATE_FORMAT);
  }

  return '-';
};

const ManifestVersion = (props) => {
  const { id, manifestId } = props.match.params;

  const pdfContainer = useRef(null);

  const [width, setWidth] = useState(998);
  const [historyList, setHistoryList] = useState([]);
  const [active, setActive] = useState(null);
  const [hideVersionNavbar, setHideVersionNavbar] = useState(false);

  useEffect(() => {
    const pdfWidth = pdfContainer?.current?.clientWidth;
    setWidth(pdfWidth);

    // Use the new consolidated API
    manifestService
      .getManifestVersionHistory(manifestId, id)
      .then((res) => {
        if (res.status === 'success' && res.data?.versions) {
          const versions = res.data.versions;
          setHistoryList(versions);
          if (versions.length > 0) {
            setActive(versions[0]);
          }
        } else {
          console.error('API response error:', res);
          toast.error('Failed to fetch manifest versions.');
        }
      })
      .catch((error) => {
        console.error('Error fetching manifest versions:', error);
        toast.error('Failed to fetch manifest versions.');
      });
  }, [manifestId, id]);

  const onClickHistory = (hist, index) => {
    setActive(hist);
  };

  const hideNavbar = () => {
    setHideVersionNavbar(!hideVersionNavbar);
  };

  return (
    <div>
      <div className='dashboard_container'>
        <div className='white'>
          <div className='back_to_board dashboard_expiration_date_nav'>
            <div className='back_button'>
              <img
                src={require('../assets/images/back.svg').default}
                alt='back'
              />{' '}
              <span>
                <Link to={`/resources/${id}`}>Back to Resource</Link>
              </span>
            </div>
            <a className='hide_nav_link btn' onClick={hideNavbar}>
              {hideVersionNavbar ? 'Display' : 'Hide'} Version Navbar
            </a>
          </div>
        </div>
        <section className='user-docs res_pdf_container'>
          <div className='onboarding-docs  sidebar-form'>
            <section className='d-flex w-100'>
              <div className='doc_info'>
                <div
                  className='doc_info-lh doc-list-lh'
                  style={{ display: hideVersionNavbar ? 'none' : '' }}
                >
                  <div className='doc-title'>
                    <h3>Version History </h3>
                  </div>
                  <div className='doc-statusbar doc-listing'>
                    <ul className='doc-lists'>
                      {historyList.map((hist, index) => (
                        <a
                          key={hist.id || index}
                          onClick={(e) => {
                            e.preventDefault();
                            onClickHistory(hist, index);
                          }}
                          href='/'
                        >
                          <li
                            className={`${
                              active?.id === hist.id
                                ? 'doc-active hist_list'
                                : 'hist_list'
                            }`}
                          >
                            <p>
                              <b className='active_green_text'>
                                {formatVersionDate(hist)}
                              </b>
                            </p>
                            {hist?.created_by_user && (
                              <p>{hist?.created_by_user}</p>
                            )}
                            {Boolean(hist?.latest_version) && (
                              <p>
                                <i>Current version</i>
                              </p>
                            )}
                          </li>
                        </a>
                      ))}
                    </ul>
                  </div>
                </div>
                <div
                  style={{ width: hideVersionNavbar ? '100%' : '' }}
                  className={`doc_info-rh fs-manifest-wrapper`}
                  ref={pdfContainer}
                >
                  {/* Document */}
                  <div className='doc-wrapper doc-wrapper-rs'>
                    {manifestId && active?.id && (
                      <ViewManifest
                        key={active?.id} // Key prop to force re-render on active.id change
                        resourceDetails={props}
                        resource_id={id}
                        manifest_id={manifestId}
                        manifest_version_id={active?.id}
                        versionData={active} // Pass the complete version data
                      />
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ManifestVersion;
